<template>
  <div id="notification">
    <div class="buttonNotification" v-click-outside="HideNotificationDropdown">
      <a :class="['fa fa-bell', { disconnect: !getNotificationReadyToUse }]" @click="ToggleNotificationDropdown()">
        <span v-if="notificationListUnreadCount > 0" class="bubble">
          <p>{{ notificationListUnreadCount > 99 ? "99+" : notificationListUnreadCount }}</p>
        </span>
      </a>
      <div :class="['dropdownNotification', { showNotification: showNotification }]">
        <div class="headerSection">
          <div class="headerTitle">
            <h3>
              {{ $t("Notification.Header") }}
              <i
                @click="(SetThisMaster(), $event.stopImmediatePropagation())"
                class="fas fa-sync-alt"
                :class="[{ 'fa-spin': animation }, { tapMaster: getNotificationIsAuthenticated }]"
              ></i>
            </h3>
            <div class="headerOption">
              <CustomSwitch :label="$t('Unread')" :checked.sync="isUnSeenOnly" @changed="ChangedIsUnSeenOnly()" />
              <button
                class="menu-option-icon"
                @click="((isShowOptionDropdown = !isShowOptionDropdown), $event.stopImmediatePropagation())"
              >
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div v-if="isShowOptionDropdown" class="dropdownBox" v-click-outside="HideOptionDropdown">
                <div @click="(DoReadAllNotification(), $event.stopImmediatePropagation())">
                  {{ $t("Notification.ReadAll_Button") }}
                </div>
              </div>
            </div>
          </div>
          <div class="headerTabs row m-0 p-0">
            <div
              v-for="(tab, index) in tabs"
              :key="index"
              class="col m-0 p-0"
              @click="((activeTab = tab.name), $event.stopImmediatePropagation())"
            >
              <div :class="['tab', { active: activeTab === tab.name }]">
                <p>{{ tab.label }}</p>
                <span v-if="tab.unreadCount > 0" class="unreadCount">{{ tab.unreadCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bodySection">
          <div
            v-show="displayNotificationList.length > 0 && !isLoading"
            ref="listBoxNotification"
            class="bodyNotification"
          >
            <div
              v-for="(notification, index) in displayNotificationList"
              :class="['notificationItem row m-0 p-0', { isUnSeen: !notification.isSeen }]"
              :key="index"
              @click="notificationIdLoading == notification.id ? '' : OnClickNotificationItemBox(notification, $event)"
            >
              <div class="col-auto mb-0 profilePicture">
                <LetterAvatar
                  :src="notification.notificationUrlImage"
                  :fullName="notification.notificationUserName"
                  :userId="notification.notificationUserId"
                  :size="32"
                  ignore-src-pattern="logo_peak-default.png"
                />
              </div>
              <div class="col-auto mb-0 statusIcon">
                <i
                  v-if="notification.icon"
                  :class="notification.icon.name"
                  :style="[{ color: notification.icon.color }]"
                ></i>
              </div>
              <div v-if="notification.message" class="col mb-0 content">
                <h3 :title="notification.message.headerMessage">
                  {{ notification.message.headerMessage }}
                </h3>
                <p v-html="notification.message.descriptionMessage"></p>
                <div>
                  <div class="dateTime">
                    {{
                      `${notification.notificationDateTime.GetDateFormat()} • ${GetTimeFormat(
                        notification.notificationDateTime,
                      )}`
                    }}
                  </div>
                  <div class="hyperLinkText">
                    {{ GetActionLabelByCategory(notification) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="displayNotificationList.length == 0 && !isLoading" class="bodyNoNotification">
            <div>
              <h3>{{ $t("Notification.No_Notification") }}</h3>
              <p>{{ $t("Notification.No_Notification_Sub") }}</p>
            </div>
          </div>
          <div v-show="isLoading">
            <div class="mx-2">
              <Skeleton class="mb-2" />
              <Skeleton class="mb-2" />
            </div>
            <div class="mx-2">
              <Skeleton class="mb-2" />
              <Skeleton class="mb-2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  BroadcastMasterGetAllNotificationListByMerchantId,
  BroadcastMasterGetIsSeenNotificationListByMerchantId,
  BroadcastMasterGetNotificationCountByMerchantId,
  BroadcastMasterGetUnSeenNotificationListByMerchantId,
} from "@/broadcastChannel/userChannel";
import LetterAvatar from "@/components/header/LetterAvatar.vue";
import {
  CookieNames,
  FinanceType,
  LoadingStatusType,
  NotificationMessageType,
  NotificationType,
  TransactionItemType,
  TransactionType,
} from "@/enums/enums";
import {
  CheckMerchantIsActiveOtherTab,
  CheckMerchantIsLoadAllNotification,
  CheckMerchantIsLoadNotificationIsSeen,
  CheckMerchantIsLoadNotificationUnSeen,
  CheckNotificationIsNotChangeURL,
  ConvertNotificationMessageListToNotificationMessageForDisplayList,
  DoGetAllNotificationList,
  DoGetIsSeenNotificationList,
  DoGetUnSeenNotificationList,
  DoGetUnseenNotificationCount,
  DoSetNotificationIsSeenAll,
  DoSetNotificationIsSeenById,
  ForceSetMaster,
  GetAllDataForDisplayNotification,
  GetIsDocumentNotification,
  GetObjectIdListNotification,
  SortDataNotification,
} from "@/helper/notificationHelper";
import { DeleteCookie, GetCookie, SetCookie } from "@/helper/shareHelper";
import { IsMasterTab } from "@/helper/tabHelper";
import { MerchantId } from "@/helper/userHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { NotificationMessageForDisplayModel } from "@/model/notification/NotificationMessageForDisplayModel";
import { NotificationMessageModel } from "@/model/notification/NotificationMessageModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const StoreNotification = namespace("Notification");
const StoreLogIn = namespace("LogIn");
const StorePrivateFile = namespace("PrivateFile");

@Component({
  components: { LetterAvatar },
})
export default class Notification extends Vue {
  private showNotification = false;
  private notificationListUnreadCount = 0;
  private isUnSeenOnly = true;
  private isShowOptionDropdown = false;
  private allNotificationList: Array<NotificationMessageForDisplayModel> = [];
  private filterNotificationList: Array<NotificationMessageForDisplayModel> = [];
  private displayNotificationList: Array<NotificationMessageForDisplayModel> = [];
  private tabs = [
    {
      name: NotificationType.None,
      label: this.$t("Notification.Tab_All"),
      unreadCount: 0,
    },
    {
      name: NotificationType.System,
      label: this.$t("Notification.Tab_System"),
      unreadCount: 0,
    },
    {
      name: NotificationType.Mention,
      label: this.$t("Notification.Tab_Mention"),
      unreadCount: 0,
    },
    {
      name: NotificationType.Download,
      label: this.$t("Notification.Tab_Download"),
      unreadCount: 0,
    },
  ];
  private activeTab = NotificationType.None;
  private animation = false;
  private isLoading = false;
  private NotificationMessageType = NotificationMessageType;
  private notificationIdLoading = null;

  @StoreNotification.Getter
  private getUnSeenNotificationList!: Array<NotificationMessageModel>;
  @StoreNotification.Getter
  private getIsSeenNotificationList!: Array<NotificationMessageModel>;
  @StoreNotification.Getter
  private getNotificationCount!: number;
  @StoreNotification.Getter
  private getNotificationReadyToUse!: boolean;
  @StoreNotification.Getter
  private getNotificationListLoadingStatus!: LoadingStatusType;
  @StoreNotification.Getter
  private getNotificationCountLoadingStatus!: LoadingStatusType;
  @StoreNotification.Getter
  private getNotificationIsAuthenticated!: LoadingStatusType;

  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;

  @StoreNotification.Action
  private DoUpdateNotificationIsSeen!: () => void;
  @StoreNotification.Action
  private DoDeleteNotificationById!: (id: string) => void;
  @StorePrivateFile.Action
  private DoGetPrivateFile!: (input: any) => void;
  @StoreNotification.Action
  private ActionSetAllNotificationListFromIndexedDB!: () => void;

  created() {
    this.isUnSeenOnly = GetCookie(CookieNames.IsGetAllNotification) ? false : true;
    if (this.getNotificationReadyToUse) {
      this.GetNotificationCount();
    }
  }

  mounted() {
    const listBoxNotification: any = this.$refs.listBoxNotification;
    listBoxNotification.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("getNotificationReadyToUse")
  getNotificationReadyToUseChanged(newVal: boolean) {
    if (!newVal) {
      this.showNotification = false;
    } else {
      this.GetNotificationCount();
    }
  }

  @Watch("getNotificationCountLoadingStatus")
  async getNotificationCountLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      this.SetUnreadCount();
      if (this.getNotificationCount > 0 && this.showNotification) {
        if (!this.isUnSeenOnly) {
          await this.GetAllNotificationList();
        } else {
          await this.GetUnSeenNotificationList();
        }
      }
    }
  }

  @Watch("getNotificationListLoadingStatus")
  async getNotificationListLoadingStatusChange(newVal: LoadingStatusType) {
    if (newVal == LoadingStatusType.Success) {
      await this.SetFilterNotificationList();
    }
  }

  @Watch("activeTab")
  async activeTabChange() {
    await this.SetFilterNotificationList();
  }

  @Watch("getNotificationIsAuthenticated")
  getNotificationIsAuthenticatedChange(newVal: boolean) {
    if (newVal) {
      this.GetNotificationCount();
    }
  }

  @Watch("showNotification")
  showNotificationChange(newVal: boolean) {
    if (!newVal) {
      this.displayNotificationList = [];
    }
  }

  public HandleScroll() {
    const listBoxNotification: any = this.$refs.listBoxNotification;
    const scrollHeight = listBoxNotification.scrollHeight;
    const scrollTop = listBoxNotification.scrollTop;
    const clientHeight = listBoxNotification.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.displayNotificationList.length < this.filterNotificationList.length) {
        this.displayNotificationList.push(this.filterNotificationList[this.displayNotificationList.length]);
      }
    }
  }

  public ResetDatalistDisplay() {
    this.displayNotificationList = [];
    if (this.filterNotificationList) {
      for (let i = 0; i < 10; i++) {
        if (i < this.filterNotificationList.length) {
          this.displayNotificationList.push(this.filterNotificationList[i]);
        }
      }
    }

    setTimeout(() => {
      this.isLoading = false;
    }, 0);
  }

  public async ToggleNotificationDropdown() {
    if (this.getNotificationReadyToUse) {
      this.showNotification = !this.showNotification;
      if (this.showNotification) {
        if (!this.isUnSeenOnly) {
          await this.GetAllNotificationList();
        } else {
          await this.GetUnSeenNotificationList();
        }
      }
    }
  }

  public HideNotificationDropdown() {
    this.showNotification = false;
  }

  public HideOptionDropdown() {
    this.isShowOptionDropdown = false;
  }

  public GetActionLabelByCategory(notification: NotificationMessageForDisplayModel) {
    switch (notification.notificationTypeId) {
      case NotificationType.Mention:
      case NotificationType.System:
        if (CheckNotificationIsNotChangeURL(notification.messageTypeId, notification.option.notificationEventType)) {
          return "";
        } else {
          return this.$t("Notification.View_Button");
        }
      case NotificationType.Download:
        return this.$t("Notification.Download_Button");
    }
    return "";
  }

  public GetTimeFormat(dateTime: any) {
    if (!dateTime) {
      return "";
    }

    const date = new Date(dateTime);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  public SetUnreadCount() {
    let systemUnreadCount = 0;
    let mentionUnreadCount = 0;
    let downloadUnreadCount = 0;

    for (const notification of this.allNotificationList) {
      systemUnreadCount +=
        Boolean(!notification.isSeen) && notification.notificationTypeId === NotificationType.System ? 1 : 0;
      mentionUnreadCount +=
        Boolean(!notification.isSeen) && notification.notificationTypeId === NotificationType.Mention ? 1 : 0;
      downloadUnreadCount +=
        Boolean(!notification.isSeen) && notification.notificationTypeId === NotificationType.Download ? 1 : 0;
    }

    this.notificationListUnreadCount = this.getNotificationCount;
    this.tabs[0].unreadCount = this.getNotificationCount;
    this.tabs[1].unreadCount = systemUnreadCount;
    this.tabs[2].unreadCount = mentionUnreadCount;
    this.tabs[3].unreadCount = downloadUnreadCount;
  }

  public async OnClickNotificationItemBox(notification: NotificationMessageForDisplayModel, event: any) {
    const notificationId = notification.id;
    const isSeen = notification.isSeen;
    const messageTypeId = notification.messageTypeId;
    const messageUrl = notification.option.messageUrl ?? "";
    const merchantId = MerchantId();
    const isDocumentNotification = GetIsDocumentNotification(messageTypeId);
    this.notificationIdLoading = null;

    if (!CheckNotificationIsNotChangeURL(messageTypeId, notification.option.notificationEventType)) {
      if (
        messageTypeId == NotificationMessageType.MentionTransaction ||
        messageTypeId == NotificationMessageType.ApprovedTransaction ||
        messageTypeId == NotificationMessageType.SendApprovedDocumentTransaction ||
        isDocumentNotification
      ) {
        const transactionId = notification.option.transactionId ?? 0;
        const transactionType = notification.option.transactionType ?? TransactionType.None;
        const financeType = notification.option.financeType ?? FinanceType.None;
        const transactionItemType = notification.option.transactionItemType ?? TransactionItemType.None;
        this.OpenTransactionDetail(transactionId, transactionType, financeType, transactionItemType, messageTypeId);
      } else if (messageTypeId == NotificationMessageType.PaymentTransfer) {
        this.OpenDownloadPrivateFile(messageUrl);
      } else if (
        messageTypeId === NotificationMessageType.AddUserToUserRole ||
        messageTypeId === NotificationMessageType.CreateOrEditUserRole ||
        messageTypeId === NotificationMessageType.UpdateUserInRole
      ) {
        this.OpenUserSetting(merchantId.PeakEncryption());
      } else if (messageTypeId == NotificationMessageType.IFSInvoice) {
        this.RedirectToIFSInvoiceDetail();
      } else {
        this.OpenNewTap(messageUrl);
      }
    }

    if (!isSeen) {
      await DoSetNotificationIsSeenById(merchantId, notificationId);
    }

    event.stopImmediatePropagation();
  }

  public OpenUserSetting(merchantId: string) {
    const url = `${process.env.VUE_APP_PeakAccount}setting/userSetting?emi=${merchantId}`;
    window.open(url, "_blank");
  }

  public OpenTransactionDetail(
    transactionId: number,
    transactionType: TransactionType,
    financeType: FinanceType,
    transactionItemType: TransactionItemType,
    messageTypeId: NotificationMessageType,
  ) {
    const baseUrl = process.env.VUE_APP_PeakAccount;
    const encryptedMerchantId = MerchantId().PeakEncryption();
    const endpointMap: any = {
      [TransactionType.ProductRequisition]: "product/productRequisitionDetail",
      [TransactionType.ReturnProductRequisition]: "product/returnProductRequisitionDetail",
      [TransactionType.PurchaseRequisition]: "expense/PurchaseRequisitionDetail",
      [TransactionType.Quotation]: financeType == FinanceType.InFlow ? "income/quotationDetail" : "expense/PODetail",
      [TransactionType.Deposit]: financeType == FinanceType.InFlow ? "income/depositDetail" : "expense/depositDetail",
      [TransactionType.GoodsReceipt]: "expense/goodsReceiptDetail",
      [TransactionType.InvoiceReceipt]: "expense/invoiceReceiptDetail",
      [TransactionType.Invoice]:
        financeType == FinanceType.InFlow
          ? "income/invoiceDetail"
          : transactionItemType == TransactionItemType.Asset
            ? "expense/fixedAssetDetail"
            : "expense/invoiceDetail",
      [TransactionType.Receipt]: "income/receiptDetail",
      [TransactionType.TaxInvoice]:
        financeType == FinanceType.InFlow ? "income/taxinvoiceDetail" : "expense/taxinvoiceDetail",
      [TransactionType.CreditNote]:
        financeType == FinanceType.InFlow ? "income/creditNoteDetail" : "expense/creditNoteDetail",
      [TransactionType.DebitNote]:
        financeType == FinanceType.InFlow ? "income/debitNoteDetail" : "expense/debitNoteDetail",
      [TransactionType.BillingNote]:
        financeType == FinanceType.InFlow ? "income/billingNoteDetail" : "expense/billingNoteDetail",
      [TransactionType.DailyJournal]: "account/dailyJournalDetail",
    };

    let url = `${baseUrl}${
      endpointMap[transactionType]
    }?emi=${encryptedMerchantId}&eii=${transactionId.PeakEncryption()}`;

    if (transactionItemType) {
      url += `&etiti=${transactionItemType.PeakEncryption()}`;
    }

    if (messageTypeId === NotificationMessageType.MentionTransaction) {
      url += "&mention=true";
    }

    window.open(url);
  }
  public RedirectToIFSInvoiceDetail() {
    const baseUrl = process.env.VUE_APP_PeakAccount;
    const encryptedMerchantId = MerchantId().PeakEncryption();
    const url = `${baseUrl}home?emi=${encryptedMerchantId}&ifsInvoice=1`;

    window.open(url);
  }
  public OpenDownloadPrivateFile(fileFullUrl: string) {
    const input = {
      blobPaths: [
        {
          blobPath: fileFullUrl,
        },
      ],
    };
    this.DoGetPrivateFile(input);
  }
  public OpenNewTap(linkDocument: string) {
    window.open(linkDocument);
  }

  public async DoReadAllNotification() {
    const merchantId = MerchantId();
    await DoSetNotificationIsSeenAll(merchantId);
  }

  public ChangedIsUnSeenOnly() {
    this.SetCookieGetAllNotification();
    if (!this.isUnSeenOnly) {
      this.GetIsSeenNotificationList();
    } else {
      this.SetFilterNotificationList();
    }
  }

  public async SetFilterNotificationList() {
    this.allNotificationList = [];
    this.isLoading = true;
    if (this.isUnSeenOnly) {
      this.allNotificationList = [
        ...ConvertNotificationMessageListToNotificationMessageForDisplayList(this.getUnSeenNotificationList),
      ];
    } else {
      this.allNotificationList = [
        ...ConvertNotificationMessageListToNotificationMessageForDisplayList(this.getUnSeenNotificationList),
        ...ConvertNotificationMessageListToNotificationMessageForDisplayList(this.getIsSeenNotificationList),
      ];
    }

    const objectId = GetObjectIdListNotification(this.allNotificationList);

    await GetAllDataForDisplayNotification(objectId, this.allNotificationList, this.getMerchant);

    this.allNotificationList = SortDataNotification(this.allNotificationList);

    if (this.activeTab === NotificationType.None) {
      this.filterNotificationList = this.allNotificationList;
    } else {
      this.filterNotificationList = this.allNotificationList.filter(
        (notification) => this.activeTab === notification.notificationTypeId,
      );
    }
    this.ResetDatalistDisplay();
    this.SetUnreadCount();
  }

  public async GetNotificationCount() {
    const merchantId = MerchantId();
    const checkMerchantIsActiveOtherTab = await CheckMerchantIsActiveOtherTab(merchantId);
    if (IsMasterTab()) {
      DoGetUnseenNotificationCount(merchantId);
    } else {
      if (checkMerchantIsActiveOtherTab) {
        this.$store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
      } else {
        BroadcastMasterGetNotificationCountByMerchantId(merchantId);
      }
    }
  }

  public async GetUnSeenNotificationList() {
    const merchantId = MerchantId();
    const checkMerchantIsLoadNotification = await CheckMerchantIsLoadNotificationUnSeen(merchantId);
    if (checkMerchantIsLoadNotification && this.getNotificationCount == 0) {
      this.$store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    } else {
      if (IsMasterTab()) {
        DoGetUnSeenNotificationList(merchantId);
      } else {
        BroadcastMasterGetUnSeenNotificationListByMerchantId(merchantId);
      }
    }
  }

  public async GetIsSeenNotificationList() {
    const merchantId = MerchantId();
    const checkMerchantIsLoadNotification = await CheckMerchantIsLoadNotificationIsSeen(merchantId);
    if (checkMerchantIsLoadNotification) {
      this.$store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    } else {
      if (IsMasterTab()) {
        DoGetIsSeenNotificationList(merchantId);
      } else {
        BroadcastMasterGetIsSeenNotificationListByMerchantId(merchantId);
      }
    }
  }

  public async GetAllNotificationList() {
    const merchantId = MerchantId();
    const checkMerchantIsLoadNotification = await CheckMerchantIsLoadAllNotification(merchantId);
    if (checkMerchantIsLoadNotification && this.getNotificationCount == 0) {
      this.ActionSetAllNotificationListFromIndexedDB();
    } else {
      if (IsMasterTab()) {
        DoGetAllNotificationList(merchantId);
      } else {
        BroadcastMasterGetAllNotificationListByMerchantId(merchantId);
      }
    }
  }

  public SetCookieGetAllNotification() {
    if (!this.isUnSeenOnly) {
      SetCookie(CookieNames.IsGetAllNotification, true, 7);
    } else {
      DeleteCookie(CookieNames.IsGetAllNotification);
    }
  }

  public async SetThisMaster() {
    this.animation = true;
    const merchantId = MerchantId();
    await ForceSetMaster(merchantId);
    setTimeout(() => {
      this.animation = false;
    }, 1000);
  }
}
</script>

<style lang="scss" scoped>
#notification {
  .buttonNotification {
    position: relative;
    z-index: 20;

    a {
      color: white;
      cursor: pointer;
      font-size: 20px;
    }

    .disconnect {
      color: rgb(141, 141, 141);
      cursor: unset;
    }

    .bubble {
      position: absolute;
      height: 16px;
      min-width: 16px;
      border-radius: 18px;
      border-radius: 18px;
      padding: 4px;
      line-height: normal;
      background-color: $alert;
      bottom: 14px;
      float: right;
      left: 40%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;

      p {
        color: #fff;
        font-size: 10px;
        @include font("lig");
      }
    }
  }

  .dropdownNotification {
    position: absolute;
    height: auto;
    width: 480px;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    z-index: 2;
    top: 30px;
    right: -14px;
    max-height: 0px;
    overflow: hidden;
    @include shadowboxLv2;
    transition: 0.25s;

    &::before {
      content: " ";
      position: absolute;
      top: -7px;
      right: 15px;
      width: 8px;
      border-bottom: 8px solid #ffffff;
      border-right: 8px solid #f5deb300;
      border-left: 8px solid #a52a2a00;
    }
  }

  .showNotification {
    max-height: unset;
    overflow: unset;
  }

  .headerSection {
    padding: 16px 8px 16px 8px;

    .headerTitle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      h3 {
        font-size: 18px;
      }
      .headerOption {
        display: flex;
        align-items: center;
        position: relative;
        i {
          cursor: pointer;
        }
        .dropdownBox {
          position: absolute;
          right: 0px;
          top: 100%;
          background: white;
          border-radius: 6px;
          min-width: 100px;
          z-index: 1;
          overflow: hidden;
          @include shadowboxLv1;
          > div {
            cursor: pointer;
            padding: 8px 12px;
            font-size: 14px;
            &:hover {
              background: $gray_hover;
            }
          }
        }
        &::v-deep {
          #customSwitch {
            .customSwitch {
              align-items: center;
            }
            p {
              font-size: 14px;
            }
          }
        }
      }
    }

    .headerTabs {
      .tab {
        width: 100%;
        padding: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        border-bottom: 1px solid transparent;
        transition: 0.5s;

        p {
          font-size: 14px;
        }

        p:hover {
          color: $purple_default;
        }

        .unreadCount {
          height: 18px;
          min-width: 18px;
          border-radius: 18px;
          padding: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          background-color: $alert;
          font-size: 12px;
          line-height: normal;
          @include font("lig");
        }
      }

      .active {
        border-bottom: 1px solid $purple_default;

        p {
          color: $purple_default;
        }
      }
    }
  }

  .bodySection {
    .bodyNotification {
      max-height: 480px;
      overflow: auto;
      transition: 0.25s;

      .notificationItem {
        padding: 8px 16px !important;
        border-bottom: 1px solid $gray_default;
        cursor: pointer;
        transition: 0.25s;

        .profilePicture {
          padding-right: 8px;
          padding-left: 0px;

          .avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .statusIcon {
          width: 20px;
          padding-left: 0px;
          padding-right: 0px;
          margin-right: 4px;
          font-size: 16px;
        }

        .content {
          padding-right: 0px;
          padding-left: 0px;

          h3 {
            font-size: 14px;
            overflow: hidden;
            margin-bottom: 4px;
            padding-right: 32px;
            display: -webkit-box;
            line-clamp: 1;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: normal;
          }

          p {
            font-size: 14px;
            overflow: hidden;
            margin-bottom: 4px;
            padding-right: 60px;
            display: -webkit-box;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          div:nth-last-child(1) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .dateTime {
              font-size: 12px;
              color: $textDisabled;
            }

            div:nth-last-child(1) {
              font-size: 14px;
            }
          }
        }
      }

      .notificationItem:hover {
        background-color: $hover !important;
      }

      .isUnSeen {
        background-color: $bgBlue;
        border-bottom: 1px solid white;
      }
    }

    .bodyNoNotification {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 120px;
      > div {
        text-align: center;
      }
    }
  }

  .hyperLinkText {
    color: $blue_default;
    font-size: 14px;
    cursor: pointer;
  }

  .fa-sync-alt {
    cursor: pointer;
    color: $text;
    font-size: 16px;
    padding: 4px 8px;
  }
  .menu-option-icon {
    background-color: white;
    border: none;
    border-radius: 100px;
    width: 24px;
    height: 24px;
    text-align: center;
    margin-left: 8px;
    &:hover {
      background-color: #f2f2f2;
    }
    &:active {
      background-color: #e0e0e0;
    }
    i {
      color: $text;
    }
  }
}
</style>
